import { render, staticRenderFns } from "./dialog-table-note.vue?vue&type=template&id=68279990&scoped=true&"
import script from "./dialog-table-note.vue?vue&type=script&lang=js&"
export * from "./dialog-table-note.vue?vue&type=script&lang=js&"
import style0 from "./dialog-table-note.vue?vue&type=style&index=0&id=68279990&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68279990",
  null
  
)

export default component.exports